import { apiRequest } from './client'

interface RecipientsResponse {
  account_id: string
  recipients: string[]
  error?: string
}

export async function getRecipients(accountId: string): Promise<string[]> {
  const result = await apiRequest<RecipientsResponse>(
    `/settings/recipients?account_id=${encodeURIComponent(accountId)}`
  )
  if (!result.success || !result.data) {
    throw new Error(result.error ?? 'Failed to load recipients')
  }
  return result.data.recipients ?? []
}

export async function setRecipients(accountId: string, recipients: string[]): Promise<void> {
  const result = await apiRequest<RecipientsResponse>('/settings/recipients', {
    method: 'PUT',
    body: JSON.stringify({ account_id: accountId, recipients }),
  })
  if (!result.success) {
    throw new Error(result.error ?? 'Failed to save recipients')
  }
}
